import { createRoutine } from 'redux-saga-routines';

// fetch
export const exportTasks = createRoutine('EXPORT_TASKS');
export const fetchAllTasks = createRoutine('FETCH_ALL_TASKS');
export const fetchTasksByEntity = createRoutine('FETCH_TASKS_BY_ENTITY');
export const fetchMoreTasksByEntity = createRoutine(
  'FETCH_MORE_TASKS_BY_ENTITY'
);
export const refreshEntityTask = createRoutine('REFRESH_ENTITY_TASK');
export const fetchTasksById = createRoutine('FETCH_TASK_BY_ID');
export const fetchTasksByIds = createRoutine('FETCH_TASK_BY_IDS');
export const fetchTaskChangelog = createRoutine('FETCH_TASK_CHANGELOG');
export const fetchPartialTasks = createRoutine('FETCH_PARTIAL_TASKS');
// add/edit
export const createTask = createRoutine('CREATE_TASK');
export const editTask = createRoutine('EDIT_TASK');
export const putTask = createRoutine('PUT_TASK');
export const editEntityTask = createRoutine('EDIT_ENTITY_TASK');
export const completeEntityTask = createRoutine('COMPLETE_ENTITY_TASK');
export const clearEntityTasks = createRoutine('CLEAR_ENTITY_TASKS');

// actions
export const archiveTask = createRoutine('ARCHIVE_TASK');
export const completeTask = createRoutine('COMPLETE_TASK');
export const resolveChecklist = createRoutine('RESOLVE_TASK');
export const markInProgressTask = createRoutine('MARK_IN_PROGRESS_TASK');
export const reAssignTask = createRoutine('REASSIGN_TASK');
export const bookmarkTask = createRoutine('BOOKMARK_TASK');

// other
export const showTaskAddEditForm = createRoutine('SHOW_TASK_ADD_EDIT_FORM');
export const setSelectedTask = createRoutine('SET_SELECTED_TASK');
export const clearSelectedTask = createRoutine('CLEAR_SELECTED_TASK');

// board view
export const fetchTaskForBoardView = createRoutine('FETCH_TASK_FOR_BOARD_VIEW');
export const refreshTaskForBoardView = createRoutine(
  'REFRESH_TASK_FOR_BOARD_VIEW'
);
export const editBoardTask = createRoutine('EDIT_BOARD_TASK');
// have to create new action to cancel refresh task since redux-saga-routines doesn't support cancel action
export const CANCEL_REFRESH_TASK = 'REFRESH_TASK/CANCEL';

// work-log
export const logTime = createRoutine('LOG_TIME');
export const deleteTaskWorkLog = createRoutine('DELETE_TASK_WORK_LOG');
